import { render } from "./RestorePasswordView.vue?vue&type=template&id=742856ed&scoped=true&ts=true&lang=pug"
import script from "./RestorePasswordView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestorePasswordView.vue?vue&type=script&lang=ts&setup=true"

import "./RestorePasswordView.vue?vue&type=style&index=0&id=742856ed&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742856ed"]])

export default __exports__